//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {getFileName} from "@/util";

export default {
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    isPendant: {
      type: Boolean,
      default: false
    },
    pendantIndex: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      text: '',
      font: 0,
      fonts: [
        {text: 'Classic'},
        {text: 'Modern'},
        {text: 'Script'},
      ],
      dragging: false,
      engravingType: 'text', // text|file
      engravingsTypes: [
        {
          text: this.$t('type'),
          value: 'text'
        },
        {
          text: `${this.$t('handwriting')} (${this.$t('uploadYours')})`,
          value: 'file'
        },
      ],
      allowedMimeType: ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'],
      allowedExtension: '.jpg .png .pdf',
      fileError: null
    }
  },
  computed: {
    characterLimit() {
      const limit = this.info?.engraving_configs?.find(conf => conf.limit)?.limit || 20
      return this.info.engraving_upload ? 7 : limit
    },
  },
  methods: {
    getFileName,
    async changeQueryT() {
      document.querySelector('#engraving-input')?.blur();
      document.querySelector('#engraving-input')?.focus();
      const textKey = this.isPendant ? `e${this.pendantIndex + 1}_sub` : 'e1';
      const fontKey = this.isPendant ? `f${this.pendantIndex + 1}_sub` : 'f1';
      const query = {...this.$route.query, [textKey]: this.text, [fontKey]: this.font};
      await this.$router.replace({query});
      this.$emit('updateCanvas');
    },
    async changeQueryF() {
      const fontKey = this.isPendant ? `f${this.pendantIndex + 1}_sub` : 'f1';
      if (this.$route.query[fontKey] !== this.font) {
        const query = {...this.$route.query, [fontKey]: this.font};
        await  this.$router.replace({query});
        this.$emit('updateCanvas');
        if (!this.isPendant) {
          window.scroll(0, 0);
        }
      }
    },

    changeEngravingType(type) {
      this.engravingType = type;
      if (type === 'text') {
        this.info.engraving_handwriting_file = null;
      } else if (type === 'file') {
        if (this.text.length) {
          this.clearEngraving();
        }
      }
    },

    toggleActive() {
      this.dragging = !this.dragging;
    },
    onChange(e) {
      const files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        this.dragging = false;
        return;
      }

      this.createFile(files[0]);
      if (e.target.value) {
        e.target.value = null
      }
    },
    createFile(file) {
      this.fileError = null
      if (file.size > 10 * 1000 * 1000) {
        this.fileError = this.$t('errorFileSize', {size: 10, unit: "MB"})
        this.dragging = false;
        return;
      }

      if (!this.allowedMimeType.includes(file.type)) {
        this.fileError = `${this.$t('errorFileFormat', {formats: 'JPG, PNG or PDF'})}`
        this.dragging = false;
        return;
      }

      this.info.engraving_handwriting_file = file;
      this.dragging = false;

      if (this.text.length) {
        this.clearEngraving();
      }
    },
    removeFile() {
      this.info.engraving_handwriting_file = null;
    },
    clearEngraving() {
      this.text = '';
      this.changeQueryT();
    }
  },
  mounted() {
    if (this.isPendant) {
      this.text = this.$route.query[`e${this.pendantIndex + 1}_sub`] || '';
      const fontQuery = this.$route.query[`f${this.pendantIndex + 1}_sub`];
      this.font = fontQuery ? Number(fontQuery) : 0;
    } else {
      this.text = this.$route.query.e1 ? this.$route.query.e1 : '';
      this.font = this.$route.query.f1 ? Number(this.$route.query.f1) : 0;
    }
    if (this.info?.engraving_handwriting_file) {
      this.engravingType = 'file';
    }
  }
}
